import React from 'react';
import { Link } from 'react-router-dom';


const Service = () => {
    const servicesData = [
        {
            id: 1,
            title: 'Website Development Services',
            description: '',
            icon: 'icon-12',
            href: '/website-development-services',
            data_aos_delay: '00ms',
        },
        {
            id: 2,
            title: 'Mobile Development Services',
            description: '',
            icon: 'icon-12',
            href: '/mobile-development-services',
            data_aos_delay: '200ms',
        },
        {
            id: 3,
            title: 'Digital Marketing Services',
            description: '',
            icon: 'icon-12',
            href: '/digital-marketing-services',
            data_aos_delay: '400ms',
        },
        {
            id: 4,
            title: 'Software Development Services',
            description: '',
            icon: 'icon-12',
            href: '/software-development-services',
            data_aos_delay: '400ms',
        },
        {
            id: 5,
            title: 'Data Management Services',
            description: '',
            icon: 'icon-12',
            href: '/data-management-services',
            data_aos_delay: '400ms',
        },
        {
            id: 6,
            title: 'Customer Relationship Management (CRM) Solutions',
            description: '',
            icon: 'icon-12',
            href: '/crm-solutions',
            data_aos_delay: '400ms',
        },

    ];
    return (
        <section className="service__section p_relative">
            <div className="auto-container">
                <div className="service__data">
                    <div className="title__data">
                        <div className="sub__title">
                            <h4>Better Future</h4>
                        </div>
                        <div className="title">
                            <h2>Our Services</h2>
                            <p>Our Services provide tailored web development, digital marketing, and data analysis solutions. We focus on quality and collaboration, helping you achieve your goals and enhance your online presence effectively.</p>
                        </div>
                    </div>
                    <div className="row">
                        {servicesData.map((item, id) => (
                            <div className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp animated" data-wow-delay={item.data_aos_delay} data-wow-duration="1500ms" key={id}>
                                <div className="service__block">
                                    <div className="service__icon">
                                        <i className={item.icon}></i>
                                        <div className="service__icon__two"></div>
                                    </div>
                                    <div className="service__text">
                                        <h4><Link to={item.href}>{item.title}</Link></h4>
                                        <p>{item.description}</p>
                                    </div>
                                    <div className="service__button">
                                        <Link to={item.href}><i className="icon-05"></i></Link>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Service;